import { Controller } from "@hotwired/stimulus";
import normalizeText from "../utils/normalize_text";

export default class extends Controller {
  static targets = [
    'textarea',
    'count'
  ];

  connect() {
    this.updateCount();
  }

  updateCount() {
    this.countTarget.textContent = normalizeText(this.textareaTarget.value).length;
  }
}
